import { render, staticRenderFns } from "./organDialog.vue?vue&type=template&id=60b411b3&scoped=true"
import script from "./organDialog.vue?vue&type=script&lang=js"
export * from "./organDialog.vue?vue&type=script&lang=js"
import style0 from "./organDialog.vue?vue&type=style&index=0&id=60b411b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b411b3",
  null
  
)

export default component.exports